import { Checkbox } from '@digdir/designsystemet-react';
import { Fragment } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CardContentWrapper } from '../../../../solceller/form/components/styledComponents';
import { TermostatstyringRadio } from '../common/termostatstyringRadio';
import { StyledCard } from '../../../../../../../components/registering/steps/base/form/detailingSelect/components/styledComponents';
import { OppvarmingFormData } from '../../../types';
import { InstallasjonsArRadio } from '../../../../../components/installasjonsArRadio';

import { useGassValidation } from './useGassValidation';

export const Gasskamin = () => {
  const { register, watch, formState } = useFormContext<OppvarmingFormData>();
  const { t } = useTranslation('', { keyPrefix: 'form.oppvarming' });
  const { validateGassSelection } = useGassValidation();

  const gassKaminSelected = watch('gass.value.kamin.selected');

  return (
    <StyledCard isActive={gassKaminSelected}>
      <CardContentWrapper>
        <Checkbox
          aria-invalid={!!formState.errors?.gass?.value?.kamin?.selected}
          label={t('gass.kamin.label')}
          {...register('gass.value.kamin.selected', {
            validate: validateGassSelection,
            deps: ['gass.value.kjel.selected'],
            shouldUnregister: true
          })}
        />
        {gassKaminSelected && (
          <Fragment>
            <InstallasjonsArRadio
              name={`gass.value.kamin.value`}
              translationKeyPrefix={`form.oppvarming.gass.kamin.installasjonsAr`}
            />
            <TermostatstyringRadio name="gass.value.kamin.value.termostatstyring" />
          </Fragment>
        )}
      </CardContentWrapper>
    </StyledCard>
  );
};
